import { api } from './baseApi';
export var productPurchasesApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getProductPurchasesStatsByProduct: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/product-purchases/stats/by-product?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Products'],
            }),
            getProductPurchasesList: builder.query({
                query: function (p) {
                    var params = new URLSearchParams();
                    Object.entries(p).forEach(function (_a) {
                        var k = _a[0], v = _a[1];
                        if (v !== undefined && v !== null && String(v) !== '')
                            params.append(k, String(v));
                    });
                    return {
                        url: "/product-purchases/list?".concat(params.toString()),
                        method: 'GET',
                    };
                },
                providesTags: ['Products'],
            }),
        });
    },
    overrideExisting: false,
});
export var useGetProductPurchasesStatsByProductQuery = productPurchasesApi.useGetProductPurchasesStatsByProductQuery, useGetProductPurchasesListQuery = productPurchasesApi.useGetProductPurchasesListQuery;
